import React, { useCallback, useEffect, useState } from 'react';
import { callNativeWeb, footerShowEventWeb } from 'common/appInterface';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router';
import { Location } from 'history';

import styles from "./CardDesignSelect.module.css";
import CardDesignOption from 'views/Apply/CardDesignSelect/CardDesignOption';
import Toast from 'components/toast/Toast';

const CardDesignSelect = () => {
  const screenId = "APPL25";
  const navigate = useNavigate();
  const location = useLocation() as Location<LocationState>;

  const { t, i18n } = useTranslation();
  const [toastMessage, setToastMessage] = useState<string | null>(null);

  const [cardApply] = useState<Partial<CardApplyCommon>>(location.state.apply);

  const [selectedDesignDivisionCode, setSelectedDesignDivisionCode] = useState("");

  const onCardClick = (designDivisionCode: string) => {
    setSelectedDesignDivisionCode(designDivisionCode);
    setToastMessage(null);
  }

  const onNextClick = useCallback(() => {
    if (selectedDesignDivisionCode === "") {
      setToastMessage(t(screenId + 'TEXT_8', "Select a card design."));

      return;
    } else {
      navigate("/apply/step2", {
        state: {
          ...location.state,
          apply: { ...cardApply, designDivisionCode: selectedDesignDivisionCode }
        }
      });
    }
  }, [t, cardApply, location.state, navigate, selectedDesignDivisionCode]);

  const callbackBackKeyEvent = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  const closeToast = () => {
    setToastMessage(null);
  };

  useEffect(() => {
    // 언어설정
    i18n.changeLanguage(location.state.query.languageCode);
    // callNative_Web 처리 (WEB > APP)
    callNativeWeb(screenId, t(screenId + ".TEXT_1", "Select Card Design"));
    // 하단바 숨기기
    footerShowEventWeb("N");
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    document.addEventListener("backpress", callbackBackKeyEvent);
    return () => document.removeEventListener("backpress", callbackBackKeyEvent);
  }, [callbackBackKeyEvent]);

  return (
    <div id="wrap">
      <div id="container" className="pcHidden">
        <div className={styles.wrapper}>
          <div className={styles.header}>
            {t(`${screenId}.TEXT_2`, "Select the card design you wish to use.")}
          </div>
          <div className={styles.cardDesignSelect}>
            <CardDesignOption screenId={screenId} cardProductCode={cardApply.cardProductCode} designDivisionCode={"B"} isSelected={selectedDesignDivisionCode === "" ? undefined : selectedDesignDivisionCode === "B"}
                              onClick={() => {
                                onCardClick("B");
                              }} />
            <CardDesignOption screenId={screenId} cardProductCode={cardApply.cardProductCode} designDivisionCode={"C"} isSelected={selectedDesignDivisionCode === "" ? undefined : selectedDesignDivisionCode === "C"}
                              onClick={() => {
                                onCardClick("C");
                              }} />
          </div>
        </div>
        <div className={`btnArea`}>
          <button className={`btnPrimaryTy01 ${selectedDesignDivisionCode === "" ? styles.disabledButton : ""}`} onClick={onNextClick}>
            <span>{t(`${screenId}.TEXT_7`, "Next")}</span>
          </button>
        </div>
      </div>
      {toastMessage && <Toast message={toastMessage} onClose={closeToast}/>}
    </div>
)
  ;
}

export default CardDesignSelect;